// @ts-strict

import { Injectable } from '@angular/core';
import { LMErrorUtilService } from '@app/services';
import { LMDrillAroundNode } from '@components/drillaround/lm-drill-around-wc';

@Injectable()
export class LMDrillNavigationService {

  private rootDataView!: LMDataView ;
  private rootDrillActions!: Array<LMDrillAction>;
  private uniqueRecordId = 1;
  private recordNodeMap = new Map<string, string>();

  constructor(
    private lmErrorUtilService: LMErrorUtilService
  ) {}

  setRootDrillRequest(rootDataView: LMDataView, rootDrillActions: Array<LMDrillAction>) {
    this.rootDataView = rootDataView;
    this.rootDrillActions = rootDrillActions;
  }

  public getRootTreeNodes(): LMDrillAroundNode[] {
    if (!this.rootDrillActions || !this.rootDataView) {
      this.lmErrorUtilService.handleError('rootDrillRequest is null');
      return [] as LMDrillAroundNode[];
    }
    const title = this.rootDataView.representativeText ? this.rootDataView.representativeText : this.rootDataView.busClassName;
    const node: LMDrillAroundNode = {
      id: '_root_',
      text: title,
      dataView: this.rootDataView,
      expanded: false
    };

    if (this.rootDataView.resourceId && node.id) {
      this.recordNodeMap.set(this.rootDataView.resourceId, node.id);
    }

    return [ node ];
  }

  public getDrillRecordNodeId(resourceId: string | undefined): string | undefined {
    return resourceId ? this.recordNodeMap.get(resourceId) : undefined;
  }

  public buildDrillRecordNode(parentNode: LMDrillAroundNode, dataView:LMDataView, drillActions?: Array<LMDrillAction>): LMDrillAroundNode {
    const title = dataView.representativeText ? dataView.representativeText : dataView.busClassName;
    const node: LMDrillAroundNode = {
      id:           parentNode.id + '-' + this.getRecordUniqueId(),
      parent:       parentNode.id,
      // icon:         'drill',
      dataView:     dataView,
      lmParent:     parentNode
    };

    (node as any)['badge'] = {
      'text': title,
      'color': 'info'
    };

    if (dataView.resourceId && node.id) {
      this.recordNodeMap.set(dataView.resourceId, node.id);
    }

    if (drillActions) {
      const drillAroundNodes = this.buildDrillAroundNodes(dataView, drillActions, node);
      node.children = drillAroundNodes; // add drillpoint nodes for the record node, idsTree.setNodes() handles this well.
      node.lmParent = parentNode;
      node.lmChildren = drillAroundNodes;
    }

    return node;
  }

  public buildDrillPanelNode(parentNode: LMDrillAroundNode, title: string): LMDrillAroundNode {

    const node: LMDrillAroundNode = {
      id:           this.getRecordUniqueId(),
      parent:       parentNode ? parentNode.id : undefined,
      text:         title,
      lmParent:     parentNode
    };

    return node;
  }

  public buildDrillAroundNodes(dataView: LMDataView, drillActions: Array<LMDrillAction>, parentNode: LMDrillAroundNode): Array<LMDrillAroundNode> {
    const nodes: Array<LMDrillAroundNode> = [];

    if (drillActions) {
      drillActions.forEach(drill => {
        nodes.push(this.buildDrillActionNode(dataView, drill, parentNode));
      });
    }

    return nodes;
  }

  private buildDrillActionNode(dataView: LMDataView, drillAction: LMDrillAction, parentNode: LMDrillAroundNode): LMDrillAroundNode {

    const node: LMDrillAroundNode = {
      id:           parentNode.id + '-' + drillAction.drillId,
      text:         drillAction.drillName,
      drillAction:  drillAction,
      dataView:     dataView,
      lmParent:     parentNode,
      // children:     undefined // drillAction.drillType === 'LIST' ? [] : undefined
    };

    return node;
  }

  private getRecordUniqueId() {

    const id = 'n' + this.uniqueRecordId;
    this.uniqueRecordId++;

    return id;
  }
}
